import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BazaWebUtilSharedService, MktSectionCommonFields, UtilModule } from '@scaliolabs/baza-web-utils';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
    selector: 'app-text-section',
    templateUrl: './text-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, UtilModule, NzGridModule],
})
export class TextSectionComponent extends MktSectionCommonFields {
    @Input()
    index = 0;

    constructor(public readonly wts: BazaWebUtilSharedService) {
        super();
    }

    public get i18nBasePath() {
        return `uic.marketing.txtSection.section${this.index}`;
    }
}
